import localStorageUtil from './localStorageUtil';

const SESSION_KEY = 'sessionId';

const sessionUtil = {
  setSession(sessionId: string): void {
    localStorageUtil.set(SESSION_KEY, sessionId);
  },

  getSession(): string | null {
    return localStorageUtil.get<string>(SESSION_KEY);
  },

  removeSession(): void {
    localStorageUtil.remove(SESSION_KEY);
  },

  hasSession(): boolean {
    return localStorageUtil.has(SESSION_KEY);
  },
};

export default sessionUtil;
